// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: #253750;
  font-size: 12px;
  --mat-form-field-container-text-size: 12px;
  --mat-select-trigger-text-size: 12px;
}

.form-container {
  padding: 24px;
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: white;
}

.product-input-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-bottom: 18px;
}

.form-inputs {
  flex: 1 1 calc(50% - 18px);
  min-width: 0;
}

.width-100,
.w-100 {
  flex-basis: 100%;
}

mat-form-field {
  display: block;
  width: 100%;
}

.field-display {
  border: 1px solid #e2e9f2;
  border-radius: 8px;
  padding: 12px;
}

.field-display > span:first-child {
  display: block;
  color: #7d8a9d;
  margin-bottom: 8px;
}

.error-msg {
  display: block;
  color: #d92d20;
  font-size: 11px;
  margin-top: 6px;
}

.select-label-text {
  display: block;
  font-size: 11px;
  color: #53647a;
  margin-bottom: 6px;
}

.title3,
.title {
  font-size: 14px;
  font-weight: 600;
  color: #172b46;
}

.note-container {
  padding: 12px 16px;
  background: #fff8e6;
  border-radius: 8px;
  margin-bottom: 16px;
}

mat-accordion {
  display: block;
  margin: 20px 0;
}

mat-expansion-panel {
  box-shadow: none !important;
  border: 1px solid #e2e9f2;
  border-radius: 8px !important;
  margin-bottom: 12px;
}

.product-bottom-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding-top: 20px;
  margin-top: 24px;
  border-top: 1px solid #edf1f6;
}

.product-bottom-container mat-spinner {
  display: inline-block;
  margin-inline-end: 8px;
}

.prev {
  cursor: pointer;
  color: var(--primary-color);
}

.listing-table,
.table-scroll {
  overflow: auto;
}

table {
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

th,
td {
  padding: 12px;
  text-align: start;
  border-bottom: 1px solid #edf1f6;
}

th {
  background: #f8fafd;
  color: #7d8a9d;
  font-weight: 500;
}

.preview-image,
.related-preview-img {
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: 8px;
}

.image-container,
.variation-image {
  display: inline-flex;
  max-width: 160px;
  padding: 8px;
  border: 1px solid #e2e9f2;
  border-radius: 8px;
  margin: 4px;
}

.image-container img,
.variation-image img {
  max-width: 100%;
  max-height: 140px;
  object-fit: contain;
}

.image-section {
  padding: 16px;
  background: #f8fafd;
  border-radius: 8px;
}

.checkbox-wrap,
.sku-check {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}

.checkbox-content {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.product-button {
  display: flex;
  justify-content: flex-end;
}

.image-upload-container,
.file-upload-container {
  border: 1px dashed #dce5ef;
  border-radius: 8px;
  padding: 20px;
}

.tag-cover-box {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.grey-box {
  padding: 6px 10px;
  background: #f1f6fd;
  border-radius: 6px;
}

.price-group-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 16px 0;
}

dt {
  color: #7d8a9d;
  font-size: 11px;
}

dd {
  margin: 6px 0;
}

@media (max-width: 650px) {
  .form-container {
    padding: 16px;
  }
  .form-inputs {
    flex-basis: 100%;
  }
  .product-input-wrap {
    gap: 14px;
  }
}
.view-page-title {
  margin: 0 0 16px;
  color: #172b46;
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
}

.view-product-page {
  display: grid;
  gap: 18px;
}

.view-product-header {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 16px;
  padding: 20px 22px;
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: #fff;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  border: 1px solid #dce5ef;
  border-radius: 8px;
  padding: 7px 12px;
  background: #fff;
  color: var(--primary-color);
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.back-button .material-symbols-outlined {
  font-size: 18px;
}

.eyebrow {
  margin: 0 0 4px;
  color: #7d8a9d;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.view-product-header h1 {
  margin: 0;
  color: #172b46;
  font-size: 20px;
  font-weight: 600;
}

.subtitle {
  margin: 4px 0 0;
  color: #7d8a9d;
  font-size: 12px;
}

.view-product-layout {
  display: grid;
  grid-template-columns: minmax(210px, 0.65fr) minmax(0, 1.35fr);
  gap: 18px;
}

.view-card {
  padding: 20px;
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: #fff;
}

.view-card h2 {
  margin: 0 0 16px;
  color: #172b46;
  font-size: 14px;
  font-weight: 600;
}

.image-grid {
  display: grid;
  min-height: 210px;
  place-items: center;
  border: 1px solid #edf1f6;
  border-radius: 9px;
  background: #fbfcfe;
}

.image-grid img {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
}

.image-empty {
  display: grid;
  place-items: center;
  gap: 6px;
  color: #8491a3;
  font-size: 12px;
}

.image-empty .material-symbols-outlined {
  font-size: 28px;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 22px;
}

.detail-item {
  display: grid;
  gap: 5px;
  padding: 12px 0;
  border-bottom: 1px solid #edf1f6;
}

.detail-item span,
.description-grid span,
.variation-details span {
  color: #7d8a9d;
  font-size: 11px;
}

.detail-item strong,
.variation-details strong {
  color: #35445b;
  font-size: 13px;
  font-weight: 500;
  word-break: break-word;
}

.description-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.description-grid > div {
  padding: 12px;
  border-radius: 8px;
  background: #fbfcfe;
}

.description-grid p {
  margin: 7px 0 0;
  color: #53647a;
  font-size: 13px;
  line-height: 1.55;
  white-space: pre-wrap;
}

.variation-details {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.variation-details div {
  display: grid;
  gap: 5px;
}

.view-product-skeleton {
  display: grid;
  gap: 18px;
}

.skeleton-header,
.skeleton-grid {
  display: grid;
  gap: 18px;
}

.skeleton-header {
  grid-template-columns: 100px 1fr;
  align-items: center;
  padding: 20px 22px;
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: #fff;
}

.skeleton-header span,
.skeleton-header i,
.skeleton-header b,
.skeleton-card i,
.skeleton-card {
  display: block;
  border-radius: 6px;
  background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);
  background-size: 400% 100%;
  animation: view-skeleton 1.35s ease infinite;
}

.skeleton-header span {
  width: 80px;
  height: 36px;
}

.skeleton-header i {
  width: 100px;
  height: 12px;
}

.skeleton-header b {
  width: 220px;
  height: 22px;
  margin-top: 8px;
}

.skeleton-grid {
  grid-template-columns: minmax(210px, 0.65fr) minmax(0, 1.35fr);
}

.skeleton-card {
  padding: 20px;
  border: 1px solid #e2e9f2;
  background: #fff;
}

.skeleton-card.image {
  min-height: 250px;
}

.skeleton-card.details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.skeleton-card.details i {
  height: 48px;
}

.skeleton-card.description {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.skeleton-card.description i {
  height: 78px;
}

@keyframes view-skeleton {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}
/* =====================================================================
   Wizard step 3 - Preview (same tokens as list / view pages)
   ===================================================================== */
:host {
  display: block;
  container-type: inline-size;
  color: #253750;
  font-size: 12px;
}

.wizard-preview {
  display: grid;
  gap: 18px;
  margin-top: 20px;
}

.preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.preview-head h2 {
  margin: 0;
  color: #172b46;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}
.preview-head p {
  margin: 2px 0 0;
  color: #7d8a9d;
  font-size: 12px;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  border: 1px solid #dce5ef;
  border-radius: 8px;
  padding: 7px 14px;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}
.button .material-symbols-outlined {
  font-size: 18px;
  line-height: 1;
}
.button.primary {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
}
.button.primary:hover:not(:disabled) {
  background: var(--primary-color-hover, var(--primary-color));
}
.button.primary ::ng-deep .mat-mdc-progress-spinner circle {
  stroke: #fff !important;
}
.button.secondary {
  background: #fff;
  color: #53647a;
}
.button.secondary:hover {
  background: color-mix(in srgb, var(--primary-color) 5%, white);
  color: var(--primary-color);
  border-color: color-mix(in srgb, var(--primary-color) 25%, white);
}
.button:disabled {
  opacity: 0.55;
  cursor: default;
}

.wizard-preview .view-card h2 {
  display: flex;
  align-items: center;
  gap: 8px;
}
.wizard-preview .view-card h2 .count {
  background: #f1f6fd;
  border-radius: 5px;
  padding: 1px 6px;
  color: #6480a4;
  font-size: 10px;
  font-weight: 500;
}

.base-images {
  display: grid;
  gap: 14px;
}
.base-images .image-grid {
  min-height: 150px;
}
.base-images .image-grid img {
  max-height: 170px;
}

.image-label {
  display: block;
  margin-bottom: 6px;
  color: #7d8a9d;
  font-size: 11px;
}

.detail-item.full {
  grid-column: 1/-1;
}

.wizard-preview .detail-item > span,
.wizard-preview .variation-details span,
.wizard-preview .image-label,
.wizard-preview .description-grid span {
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-size: 10px;
}
.wizard-preview .view-card > h2 {
  text-transform: capitalize;
}

.chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  display: inline-flex;
  align-items: center;
  border-radius: 20px;
  padding: 3px 10px;
  background: #f1f6fd;
  color: #3d5a80;
  font-size: 11px;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 20px;
  padding: 3px 8px;
  background: #f1f3f7;
  color: #7d8a9d;
  font-size: 10px;
  text-transform: capitalize;
}
.status > span {
  width: 4px;
  height: 4px;
  background: currentColor;
  border-radius: 50%;
}
.status.enabled {
  background: #eef7f2;
  color: #36866a;
}

.variation-list {
  display: grid;
  gap: 10px;
}
.variation-list .mat-expansion-panel {
  border: 1px solid #e2e9f2;
  border-radius: 10px !important;
  box-shadow: none !important;
  overflow: hidden;
}
.variation-list .mat-expansion-panel ::ng-deep .mat-expansion-panel-header {
  height: 48px !important;
  padding: 0 16px !important;
  background: #fbfcfe;
  border-bottom: 1px solid #edf1f6;
}
.variation-list .mat-expansion-panel ::ng-deep .mat-expansion-panel-body {
  padding: 14px 16px 16px !important;
}
.variation-list mat-panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.variation-list .variation-title {
  color: var(--primary-color);
  font-size: 13px;
  font-weight: 500;
}
.variation-list .variation-details {
  padding: 4px 0 14px;
  border-bottom: 1px solid #edf1f6;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
}

.variation-images {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 14px 0 4px;
}

.thumb-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 64px;
  align-items: center;
}

.thumb {
  width: 64px;
  height: 64px;
  border: 1px solid #e2e9f2;
  border-radius: 8px;
  background: #fbfcfe;
  overflow: hidden;
}
.thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.thumb.cover {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 1px var(--primary-color);
}

.thumb-empty {
  display: inline-flex;
  align-items: center;
  height: 64px;
  padding: 0 14px;
  border: 1px dashed #dce5ef;
  border-radius: 8px;
  color: #8491a3;
  font-size: 11px;
}

.table-scroll {
  overflow-x: auto;
  border: 1px solid #e2e9f2;
  border-radius: 10px;
  margin-top: 12px;
  scrollbar-width: thin;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}
.data-table th {
  background: #fbfcfe;
  color: #7d8a9d;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
}
.data-table th,
.data-table td {
  padding: 11px 14px;
  text-align: start;
  border-bottom: 1px solid #edf1f6;
  vertical-align: middle;
}
.data-table tbody tr:last-child td {
  border-bottom: 0;
}
.data-table tbody tr:hover {
  background: #fcfdff;
}
.data-table .code {
  color: var(--primary-color);
  font-weight: 500;
}
.data-table .muted {
  color: #8491a3;
  white-space: nowrap;
}
.data-table .row-img {
  width: 34px;
  height: 34px;
  border-radius: 7px;
  object-fit: contain;
  background: #f7f9fc;
}

.view-card .table-scroll:first-of-type {
  margin-top: 0;
}

.preview-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #edf1f6;
}

@container (max-width: 760px) {
  .view-product-layout,
  .description-grid,
  .variation-images {
    grid-template-columns: 1fr;
  }
  .base-images {
    grid-template-columns: 1fr 1fr;
  }
}
@container (max-width: 480px) {
  .preview-head {
    flex-direction: column;
    align-items: stretch;
  }
  .preview-head .button {
    width: 100%;
  }
  .detail-grid,
  .base-images {
    grid-template-columns: 1fr;
  }
  .view-card {
    padding: 16px;
  }
  .preview-footer .button {
    flex: 1;
  }
}
:host {
  --pv-ink: var(--primary-font-color, #172b46);
  --pv-text: var(--primary-font-color, #35445b);
  --pv-muted: var(--secondary-grey-color, #7d8a9d);
  --pv-border: color-mix(in srgb, var(--grey-border, #D5D7DA) 70%, white);
  --pv-divider: color-mix(in srgb, var(--grey-border, #D5D7DA) 45%, white);
  --pv-soft: color-mix(in srgb, var(--primary-color) 3%, white);
  --pv-tint: color-mix(in srgb, var(--primary-color) 8%, white);
  --pv-tint-text: color-mix(in srgb, var(--primary-color) 75%, black);
  color: var(--pv-text);
}

.view-card,
.view-product-header,
.table-scroll,
.variation-list .mat-expansion-panel,
.thumb,
.back-button,
.button.secondary {
  border-color: var(--pv-border);
}

.detail-item,
.preview-footer,
.data-table th,
.data-table td,
.variation-list .variation-details,
.image-grid {
  border-color: var(--pv-divider);
}

.view-card h2,
.view-product-header h1,
.view-page-title,
.preview-head h2,
.detail-item strong,
.variation-details strong {
  color: var(--pv-ink);
}

.detail-item span,
.description-grid span,
.variation-details span,
.image-label,
.preview-head p,
.eyebrow,
.subtitle,
.data-table th,
.data-table .muted,
.image-empty,
.thumb-empty {
  color: var(--pv-muted);
}

.description-grid p,
.button.secondary {
  color: var(--pv-text);
}

.description-grid > div,
.image-grid,
.thumb,
.data-table th,
.data-table .row-img {
  background: var(--pv-soft);
}

.chip,
.wizard-preview .view-card h2 .count {
  background: var(--pv-tint);
  color: var(--pv-tint-text);
}

.thumb-empty {
  border-color: var(--pv-border);
}

.variation-list .mat-expansion-panel ::ng-deep .mat-expansion-panel-header {
  background: var(--pv-soft);
  border-bottom-color: var(--pv-divider);
}

@media (max-width: 700px) {
  .view-product-header {
    grid-template-columns: 1fr;
  }
  .view-product-layout,
  .description-grid,
  .skeleton-grid {
    grid-template-columns: 1fr;
  }
  .detail-grid {
    grid-template-columns: 1fr;
  }
  .variation-details {
    grid-template-columns: repeat(2, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/product-editor.scss","webpack://./src/app/components/product-preview/product-preview.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,0CAAA;EACA,oCAAA;ACCJ;;ADEA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,0BAAA;EACA,YAAA;ACCJ;;ADEA;;EAEI,gBAAA;ACCJ;;ADEA;EACI,cAAA;EACA,WAAA;ACCJ;;ADEA;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;ACCJ;;ADEA;EACI,cAAA;EACA,cAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;ACCJ;;ADEA;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ACCJ;;ADEA;;EAEI,eAAA;EACA,gBAAA;EACA,cAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,cAAA;EACA,cAAA;ACCJ;;ADEA;EACI,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;ACCJ;;ADEA;EACI,qBAAA;EACA,sBAAA;ACCJ;;ADEA;EACI,eAAA;EACA,2BAAA;ACCJ;;ADEA;;EAEI,cAAA;ACCJ;;ADEA;EACI,yBAAA;EACA,WAAA;EACA,eAAA;ACCJ;;ADEA;;EAEI,aAAA;EACA,iBAAA;EACA,gCAAA;ACCJ;;ADEA;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;ACCJ;;ADEA;;EAEI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;ACCJ;;ADEA;;EAEI,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;ACCJ;;ADEA;;EAEI,eAAA;EACA,iBAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;ACCJ;;ADEA;;EAEI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;ACCJ;;ADEA;EACI,aAAA;EACA,yBAAA;ACCJ;;ADEA;;EAEI,0BAAA;EACA,kBAAA;EACA,aAAA;ACCJ;;ADEA;EACI,aAAA;EACA,QAAA;EACA,eAAA;ACCJ;;ADEA;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;ACCJ;;ADEA;EACI,cAAA;EACA,eAAA;ACCJ;;ADEA;EACI,aAAA;ACCJ;;ADEA;EACI;IACI,aAAA;ECCN;EDEE;IACI,gBAAA;ECAN;EDGE;IACI,SAAA;ECDN;AACF;AAnOA;EACI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,SAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,+BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAqOJ;;AAlOA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AAqOJ;;AAlOA;EACI,eAAA;AAqOJ;;AAlOA;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AAqOJ;;AAlOA;EACI,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAqOJ;;AAlOA;EACI,eAAA;EACA,cAAA;EACA,eAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,8DAAA;EACA,SAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAqOJ;;AAlOA;EACI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAqOJ;;AAlOA;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAqOJ;;AAlOA;EACI,eAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,gDAAA;EACA,WAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,QAAA;EACA,eAAA;EACA,gCAAA;AAqOJ;;AAlOA;;;EAGI,cAAA;EACA,eAAA;AAqOJ;;AAlOA;;EAEI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;AAqOJ;;AAlOA;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,qCAAA;EACA,SAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,QAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,SAAA;AAqOJ;;AAlOA;;EAEI,aAAA;EACA,SAAA;AAqOJ;;AAlOA;EACI,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAqOJ;;AAlOA;;;;;EAKI,cAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,4CAAA;AAqOJ;;AAlOA;EACI,WAAA;EACA,YAAA;AAqOJ;;AAlOA;EACI,YAAA;EACA,YAAA;AAqOJ;;AAlOA;EACI,YAAA;EACA,YAAA;EACA,eAAA;AAqOJ;;AAlOA;EACI,8DAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,yBAAA;EACA,gBAAA;AAqOJ;;AAlOA;EACI,iBAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAqOJ;;AAlOA;EACI,YAAA;AAqOJ;;AAlOA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAqOJ;;AAlOA;EACI,YAAA;AAqOJ;;AAlOA;EACI;IACI,2BAAA;EAqON;EAlOE;IACI,wBAAA;EAoON;AACF;AAjOA;;0EAAA;AAGA;EACI,cAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;AAmOJ;;AAhOA;EACI,aAAA;EACA,SAAA;EACA,gBAAA;AAmOJ;;AAhOA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAmOJ;AAjOI;EACI,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAmOR;AAhOI;EACI,eAAA;EACA,cAAA;EACA,eAAA;AAkOR;;AA9NA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAiOJ;AA/NI;EACI,eAAA;EACA,cAAA;AAiOR;AA9NI;EACI,gCAAA;EACA,kCAAA;EACA,WAAA;AAgOR;AA9NQ;EACI,4DAAA;AAgOZ;AA7NQ;EACI,uBAAA;AA+NZ;AA3NI;EACI,gBAAA;EACA,cAAA;AA6NR;AA3NQ;EACI,8DAAA;EACA,2BAAA;EACA,iEAAA;AA6NZ;AAzNI;EACI,aAAA;EACA,eAAA;AA2NR;;AAvNA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AA0NJ;AAxNI;EACI,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA0NR;;AAtNA;EACI,aAAA;EACA,SAAA;AAyNJ;AAvNI;EACI,iBAAA;AAyNR;AAvNQ;EACI,iBAAA;AAyNZ;;AApNA;EACI,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAuNJ;;AApNA;EACI,iBAAA;AAuNJ;;AAjNI;;;;EAII,yBAAA;EACA,qBAAA;EACA,eAAA;AAoNR;AAjNI;EACI,0BAAA;AAmNR;;AA/MA;EACI,aAAA;EACA,eAAA;EACA,QAAA;AAkNJ;;AA/MA;EACI,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAkNJ;;AA/MA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;AAkNJ;AAhNI;EACI,UAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;AAkNR;AA/MI;EACI,mBAAA;EACA,cAAA;AAiNR;;AA7MA;EACI,aAAA;EACA,SAAA;AAgNJ;AA9MI;EACI,yBAAA;EACA,8BAAA;EACA,2BAAA;EACA,gBAAA;AAgNR;AA9MQ;EACI,uBAAA;EACA,0BAAA;EACA,mBAAA;EACA,gCAAA;AAgNZ;AA7MQ;EACI,kCAAA;AA+MZ;AA3MI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AA6MR;AA1MI;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;AA4MR;AAzMI;EACI,mBAAA;EACA,gCAAA;EACA,2DAAA;AA2MR;;AAvMA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AA0MJ;;AAvMA;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AA0MJ;;AAvMA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA0MJ;AAxMI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AA0MR;AAvMI;EACI,kCAAA;EACA,0CAAA;AAyMR;;AArMA;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAwMJ;;AArMA;EACI,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAwMJ;;AArMA;EACI,WAAA;EACA,yBAAA;EACA,eAAA;AAwMJ;AAtMI;EACI,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAwMR;AArMI;;EAEI,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,sBAAA;AAuMR;AApMI;EACI,gBAAA;AAsMR;AAnMI;EACI,mBAAA;AAqMR;AAlMI;EACI,2BAAA;EACA,gBAAA;AAoMR;AAjMI;EACI,cAAA;EACA,mBAAA;AAmMR;AAhMI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAkMR;;AA9LA;EACI,aAAA;AAiMJ;;AA9LA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAiMJ;;AA7LA;EAEI;;;IAGI,0BAAA;EA+LN;EA5LE;IACI,8BAAA;EA8LN;AACF;AA3LA;EACI;IACI,sBAAA;IACA,oBAAA;EA6LN;EA3LM;IACI,WAAA;EA6LV;EAzLE;;IAEI,0BAAA;EA2LN;EAxLE;IACI,aAAA;EA0LN;EAvLE;IACI,OAAA;EAyLN;AACF;AAlLA;EACI,4CAAA;EACA,6CAAA;EACA,gDAAA;EACA,uEAAA;EACA,wEAAA;EACA,6DAAA;EACA,6DAAA;EACA,mEAAA;EACA,qBAAA;AAoLJ;;AAjLA;;;;;;;EAOI,8BAAA;AAoLJ;;AAjLA;;;;;;EAMI,+BAAA;AAoLJ;;AAjLA;;;;;;EAMI,oBAAA;AAoLJ;;AAjLA;;;;;;;;;;;EAWI,sBAAA;AAoLJ;;AAjLA;;EAEI,qBAAA;AAoLJ;;AAjLA;;;;;EAKI,0BAAA;AAoLJ;;AAjLA;;EAEI,0BAAA;EACA,0BAAA;AAoLJ;;AAjLA;EACI,8BAAA;AAoLJ;;AAjLA;EACI,0BAAA;EACA,sCAAA;AAoLJ;;AAjLA;EACI;IACI,0BAAA;EAoLN;EAjLE;;;IAGI,0BAAA;EAmLN;EAhLE;IACI,0BAAA;EAkLN;EA/KE;IACI,qCAAA;EAiLN;AACF","sourcesContent":[":host {\n    display: block;\n    color: #253750;\n    font-size: 12px;\n    --mat-form-field-container-text-size: 12px;\n    --mat-select-trigger-text-size: 12px;\n}\n\n.form-container {\n    padding: 24px;\n    border: 1px solid #e2e9f2;\n    border-radius: 12px;\n    background: white;\n}\n\n.product-input-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 18px;\n    margin-bottom: 18px;\n}\n\n.form-inputs {\n    flex: 1 1 calc(50% - 18px);\n    min-width: 0;\n}\n\n.width-100,\n.w-100 {\n    flex-basis: 100%;\n}\n\nmat-form-field {\n    display: block;\n    width: 100%;\n}\n\n.field-display {\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    padding: 12px;\n}\n\n.field-display>span:first-child {\n    display: block;\n    color: #7d8a9d;\n    margin-bottom: 8px;\n}\n\n.error-msg {\n    display: block;\n    color: #d92d20;\n    font-size: 11px;\n    margin-top: 6px;\n}\n\n.select-label-text {\n    display: block;\n    font-size: 11px;\n    color: #53647a;\n    margin-bottom: 6px;\n}\n\n.title3,\n.title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #172b46;\n}\n\n.note-container {\n    padding: 12px 16px;\n    background: #fff8e6;\n    border-radius: 8px;\n    margin-bottom: 16px;\n}\n\nmat-accordion {\n    display: block;\n    margin: 20px 0;\n}\n\nmat-expansion-panel {\n    box-shadow: none !important;\n    border: 1px solid #e2e9f2;\n    border-radius: 8px !important;\n    margin-bottom: 12px;\n}\n\n.product-bottom-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding-top: 20px;\n    margin-top: 24px;\n    border-top: 1px solid #edf1f6;\n}\n\n.product-bottom-container mat-spinner {\n    display: inline-block;\n    margin-inline-end: 8px;\n}\n\n.prev {\n    cursor: pointer;\n    color: var(--primary-color);\n}\n\n.listing-table,\n.table-scroll {\n    overflow: auto;\n}\n\ntable {\n    border-collapse: collapse;\n    width: 100%;\n    font-size: 12px;\n}\n\nth,\ntd {\n    padding: 12px;\n    text-align: start;\n    border-bottom: 1px solid #edf1f6;\n}\n\nth {\n    background: #f8fafd;\n    color: #7d8a9d;\n    font-weight: 500;\n}\n\n.preview-image,\n.related-preview-img {\n    width: 48px;\n    height: 48px;\n    object-fit: contain;\n    border-radius: 8px;\n}\n\n.image-container,\n.variation-image {\n    display: inline-flex;\n    max-width: 160px;\n    padding: 8px;\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    margin: 4px;\n}\n\n.image-container img,\n.variation-image img {\n    max-width: 100%;\n    max-height: 140px;\n    object-fit: contain;\n}\n\n.image-section {\n    padding: 16px;\n    background: #f8fafd;\n    border-radius: 8px;\n}\n\n.checkbox-wrap,\n.sku-check {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    align-items: center;\n}\n\n.checkbox-content {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n}\n\n.product-button {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.image-upload-container,\n.file-upload-container {\n    border: 1px dashed #dce5ef;\n    border-radius: 8px;\n    padding: 20px;\n}\n\n.tag-cover-box {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.grey-box {\n    padding: 6px 10px;\n    background: #f1f6fd;\n    border-radius: 6px;\n}\n\n.price-group-summary {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 24px;\n    padding: 16px 0;\n}\n\ndt {\n    color: #7d8a9d;\n    font-size: 11px;\n}\n\ndd {\n    margin: 6px 0;\n}\n\n@media(max-width:650px) {\n    .form-container {\n        padding: 16px;\n    }\n\n    .form-inputs {\n        flex-basis: 100%;\n    }\n\n    .product-input-wrap {\n        gap: 14px;\n    }\n}","@import '../../../theme/product-editor';\n\n.view-page-title {\n    margin: 0 0 16px;\n    color: #172b46;\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 30px\n}\n\n.view-product-page {\n    display: grid;\n    gap: 18px\n}\n\n.view-product-header {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    align-items: center;\n    gap: 16px;\n    padding: 20px 22px;\n    border: 1px solid #e2e9f2;\n    border-radius: 12px;\n    background: #fff\n}\n\n.back-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    min-height: 36px;\n    border: 1px solid #dce5ef;\n    border-radius: 8px;\n    padding: 7px 12px;\n    background: #fff;\n    color: var(--primary-color);\n    font: inherit;\n    font-size: 12px;\n    cursor: pointer\n}\n\n.back-button .material-symbols-outlined {\n    font-size: 18px\n}\n\n.eyebrow {\n    margin: 0 0 4px;\n    color: #7d8a9d;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: .04em\n}\n\n.view-product-header h1 {\n    margin: 0;\n    color: #172b46;\n    font-size: 20px;\n    font-weight: 600\n}\n\n.subtitle {\n    margin: 4px 0 0;\n    color: #7d8a9d;\n    font-size: 12px\n}\n\n.view-product-layout {\n    display: grid;\n    grid-template-columns: minmax(210px, .65fr) minmax(0, 1.35fr);\n    gap: 18px\n}\n\n.view-card {\n    padding: 20px;\n    border: 1px solid #e2e9f2;\n    border-radius: 12px;\n    background: #fff\n}\n\n.view-card h2 {\n    margin: 0 0 16px;\n    color: #172b46;\n    font-size: 14px;\n    font-weight: 600\n}\n\n.image-grid {\n    display: grid;\n    min-height: 210px;\n    place-items: center;\n    border: 1px solid #edf1f6;\n    border-radius: 9px;\n    background: #fbfcfe\n}\n\n.image-grid img {\n    max-width: 100%;\n    max-height: 250px;\n    object-fit: contain\n}\n\n.image-empty {\n    display: grid;\n    place-items: center;\n    gap: 6px;\n    color: #8491a3;\n    font-size: 12px\n}\n\n.image-empty .material-symbols-outlined {\n    font-size: 28px\n}\n\n.detail-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0 22px\n}\n\n.detail-item {\n    display: grid;\n    gap: 5px;\n    padding: 12px 0;\n    border-bottom: 1px solid #edf1f6\n}\n\n.detail-item span,\n.description-grid span,\n.variation-details span {\n    color: #7d8a9d;\n    font-size: 11px\n}\n\n.detail-item strong,\n.variation-details strong {\n    color: #35445b;\n    font-size: 13px;\n    font-weight: 500;\n    word-break: break-word\n}\n\n.description-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px\n}\n\n.description-grid>div {\n    padding: 12px;\n    border-radius: 8px;\n    background: #fbfcfe\n}\n\n.description-grid p {\n    margin: 7px 0 0;\n    color: #53647a;\n    font-size: 13px;\n    line-height: 1.55;\n    white-space: pre-wrap\n}\n\n.variation-details {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 12px\n}\n\n.variation-details div {\n    display: grid;\n    gap: 5px\n}\n\n.view-product-skeleton {\n    display: grid;\n    gap: 18px\n}\n\n.skeleton-header,\n.skeleton-grid {\n    display: grid;\n    gap: 18px\n}\n\n.skeleton-header {\n    grid-template-columns: 100px 1fr;\n    align-items: center;\n    padding: 20px 22px;\n    border: 1px solid #e2e9f2;\n    border-radius: 12px;\n    background: #fff\n}\n\n.skeleton-header span,\n.skeleton-header i,\n.skeleton-header b,\n.skeleton-card i,\n.skeleton-card {\n    display: block;\n    border-radius: 6px;\n    background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);\n    background-size: 400% 100%;\n    animation: view-skeleton 1.35s ease infinite\n}\n\n.skeleton-header span {\n    width: 80px;\n    height: 36px\n}\n\n.skeleton-header i {\n    width: 100px;\n    height: 12px\n}\n\n.skeleton-header b {\n    width: 220px;\n    height: 22px;\n    margin-top: 8px\n}\n\n.skeleton-grid {\n    grid-template-columns: minmax(210px, .65fr) minmax(0, 1.35fr)\n}\n\n.skeleton-card {\n    padding: 20px;\n    border: 1px solid #e2e9f2;\n    background: #fff\n}\n\n.skeleton-card.image {\n    min-height: 250px\n}\n\n.skeleton-card.details {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px\n}\n\n.skeleton-card.details i {\n    height: 48px\n}\n\n.skeleton-card.description {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px\n}\n\n.skeleton-card.description i {\n    height: 78px\n}\n\n@keyframes view-skeleton {\n    0% {\n        background-position: 100% 0\n    }\n\n    100% {\n        background-position: 0 0\n    }\n}\n\n/* =====================================================================\n   Wizard step 3 - Preview (same tokens as list / view pages)\n   ===================================================================== */\n:host {\n    display: block;\n    container-type: inline-size;\n    color: #253750;\n    font-size: 12px;\n}\n\n.wizard-preview {\n    display: grid;\n    gap: 18px;\n    margin-top: 20px;\n}\n\n.preview-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n\n    h2 {\n        margin: 0;\n        color: #172b46;\n        font-size: 16px;\n        line-height: 24px;\n        font-weight: 600;\n    }\n\n    p {\n        margin: 2px 0 0;\n        color: #7d8a9d;\n        font-size: 12px;\n    }\n}\n\n.button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 7px;\n    min-height: 36px;\n    border: 1px solid #dce5ef;\n    border-radius: 8px;\n    padding: 7px 14px;\n    font: inherit;\n    font-size: 12px;\n    font-weight: 500;\n    cursor: pointer;\n    white-space: nowrap;\n\n    .material-symbols-outlined {\n        font-size: 18px;\n        line-height: 1;\n    }\n\n    &.primary {\n        background: var(--primary-color);\n        border-color: var(--primary-color);\n        color: #fff;\n\n        &:hover:not(:disabled) {\n            background: var(--primary-color-hover, var(--primary-color));\n        }\n\n        ::ng-deep .mat-mdc-progress-spinner circle {\n            stroke: #fff !important;\n        }\n    }\n\n    &.secondary {\n        background: #fff;\n        color: #53647a;\n\n        &:hover {\n            background: color-mix(in srgb, var(--primary-color) 5%, white);\n            color: var(--primary-color);\n            border-color: color-mix(in srgb, var(--primary-color) 25%, white);\n        }\n    }\n\n    &:disabled {\n        opacity: .55;\n        cursor: default;\n    }\n}\n\n.wizard-preview .view-card h2 {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    .count {\n        background: #f1f6fd;\n        border-radius: 5px;\n        padding: 1px 6px;\n        color: #6480a4;\n        font-size: 10px;\n        font-weight: 500;\n    }\n}\n\n.base-images {\n    display: grid;\n    gap: 14px;\n\n    .image-grid {\n        min-height: 150px;\n\n        img {\n            max-height: 170px;\n        }\n    }\n}\n\n.image-label {\n    display: block;\n    margin-bottom: 6px;\n    color: #7d8a9d;\n    font-size: 11px;\n}\n\n.detail-item.full {\n    grid-column: 1 / -1;\n}\n\n// Consistent labels (translations mix \"brand\", \"Product unit\", \"SKU\")\n.wizard-preview {\n\n    .detail-item>span,\n    .variation-details span,\n    .image-label,\n    .description-grid span {\n        text-transform: uppercase;\n        letter-spacing: .3px;\n        font-size: 10px;\n    }\n\n    .view-card>h2 {\n        text-transform: capitalize;\n    }\n}\n\n.chip-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.chip {\n    display: inline-flex;\n    align-items: center;\n    border-radius: 20px;\n    padding: 3px 10px;\n    background: #f1f6fd;\n    color: #3d5a80;\n    font-size: 11px;\n}\n\n.status {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    border-radius: 20px;\n    padding: 3px 8px;\n    background: #f1f3f7;\n    color: #7d8a9d;\n    font-size: 10px;\n    text-transform: capitalize;\n\n    >span {\n        width: 4px;\n        height: 4px;\n        background: currentColor;\n        border-radius: 50%;\n    }\n\n    &.enabled {\n        background: #eef7f2;\n        color: #36866a;\n    }\n}\n\n.variation-list {\n    display: grid;\n    gap: 10px;\n\n    .mat-expansion-panel {\n        border: 1px solid #e2e9f2;\n        border-radius: 10px !important;\n        box-shadow: none !important;\n        overflow: hidden;\n\n        ::ng-deep .mat-expansion-panel-header {\n            height: 48px !important;\n            padding: 0 16px !important;\n            background: #fbfcfe;\n            border-bottom: 1px solid #edf1f6;\n        }\n\n        ::ng-deep .mat-expansion-panel-body {\n            padding: 14px 16px 16px !important;\n        }\n    }\n\n    mat-panel-title {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n    }\n\n    .variation-title {\n        color: var(--primary-color);\n        font-size: 13px;\n        font-weight: 500;\n    }\n\n    .variation-details {\n        padding: 4px 0 14px;\n        border-bottom: 1px solid #edf1f6;\n        grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n    }\n}\n\n.variation-images {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    padding: 14px 0 4px;\n}\n\n.thumb-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    min-height: 64px;\n    align-items: center;\n}\n\n.thumb {\n    width: 64px;\n    height: 64px;\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    background: #fbfcfe;\n    overflow: hidden;\n\n    img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n    }\n\n    &.cover {\n        border-color: var(--primary-color);\n        box-shadow: 0 0 0 1px var(--primary-color);\n    }\n}\n\n.thumb-empty {\n    display: inline-flex;\n    align-items: center;\n    height: 64px;\n    padding: 0 14px;\n    border: 1px dashed #dce5ef;\n    border-radius: 8px;\n    color: #8491a3;\n    font-size: 11px;\n}\n\n.table-scroll {\n    overflow-x: auto;\n    border: 1px solid #e2e9f2;\n    border-radius: 10px;\n    margin-top: 12px;\n    scrollbar-width: thin;\n}\n\n.data-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 11px;\n\n    th {\n        background: #fbfcfe;\n        color: #7d8a9d;\n        font-size: 10px;\n        font-weight: 500;\n        white-space: nowrap;\n    }\n\n    th,\n    td {\n        padding: 11px 14px;\n        text-align: start;\n        border-bottom: 1px solid #edf1f6;\n        vertical-align: middle;\n    }\n\n    tbody tr:last-child td {\n        border-bottom: 0;\n    }\n\n    tbody tr:hover {\n        background: #fcfdff;\n    }\n\n    .code {\n        color: var(--primary-color);\n        font-weight: 500;\n    }\n\n    .muted {\n        color: #8491a3;\n        white-space: nowrap;\n    }\n\n    .row-img {\n        width: 34px;\n        height: 34px;\n        border-radius: 7px;\n        object-fit: contain;\n        background: #f7f9fc;\n    }\n}\n\n.view-card .table-scroll:first-of-type {\n    margin-top: 0;\n}\n\n.preview-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding-top: 16px;\n    border-top: 1px solid #edf1f6;\n}\n\n// Narrow content area (sidebar open) / tablets\n@container (max-width: 760px) {\n\n    .view-product-layout,\n    .description-grid,\n    .variation-images {\n        grid-template-columns: 1fr;\n    }\n\n    .base-images {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n@container (max-width: 480px) {\n    .preview-head {\n        flex-direction: column;\n        align-items: stretch;\n\n        .button {\n            width: 100%;\n        }\n    }\n\n    .detail-grid,\n    .base-images {\n        grid-template-columns: 1fr;\n    }\n\n    .view-card {\n        padding: 16px;\n    }\n\n    .preview-footer .button {\n        flex: 1;\n    }\n}\n\n// ---------------------------------------------------------------------\n// Theme tokens: colours come from the theme config (ThemeConfigurationService)\n// Hex values are only fallbacks.\n// ---------------------------------------------------------------------\n:host {\n    --pv-ink: var(--primary-font-color, #172b46);\n    --pv-text: var(--primary-font-color, #35445b);\n    --pv-muted: var(--secondary-grey-color, #7d8a9d);\n    --pv-border: color-mix(in srgb, var(--grey-border, #D5D7DA) 70%, white);\n    --pv-divider: color-mix(in srgb, var(--grey-border, #D5D7DA) 45%, white);\n    --pv-soft: color-mix(in srgb, var(--primary-color) 3%, white);\n    --pv-tint: color-mix(in srgb, var(--primary-color) 8%, white);\n    --pv-tint-text: color-mix(in srgb, var(--primary-color) 75%, black);\n    color: var(--pv-text);\n}\n\n.view-card,\n.view-product-header,\n.table-scroll,\n.variation-list .mat-expansion-panel,\n.thumb,\n.back-button,\n.button.secondary {\n    border-color: var(--pv-border);\n}\n\n.detail-item,\n.preview-footer,\n.data-table th,\n.data-table td,\n.variation-list .variation-details,\n.image-grid {\n    border-color: var(--pv-divider);\n}\n\n.view-card h2,\n.view-product-header h1,\n.view-page-title,\n.preview-head h2,\n.detail-item strong,\n.variation-details strong {\n    color: var(--pv-ink);\n}\n\n.detail-item span,\n.description-grid span,\n.variation-details span,\n.image-label,\n.preview-head p,\n.eyebrow,\n.subtitle,\n.data-table th,\n.data-table .muted,\n.image-empty,\n.thumb-empty {\n    color: var(--pv-muted);\n}\n\n.description-grid p,\n.button.secondary {\n    color: var(--pv-text);\n}\n\n.description-grid>div,\n.image-grid,\n.thumb,\n.data-table th,\n.data-table .row-img {\n    background: var(--pv-soft);\n}\n\n.chip,\n.wizard-preview .view-card h2 .count {\n    background: var(--pv-tint);\n    color: var(--pv-tint-text);\n}\n\n.thumb-empty {\n    border-color: var(--pv-border);\n}\n\n.variation-list .mat-expansion-panel ::ng-deep .mat-expansion-panel-header {\n    background: var(--pv-soft);\n    border-bottom-color: var(--pv-divider);\n}\n\n@media(max-width:700px) {\n    .view-product-header {\n        grid-template-columns: 1fr\n    }\n\n    .view-product-layout,\n    .description-grid,\n    .skeleton-grid {\n        grid-template-columns: 1fr\n    }\n\n    .detail-grid {\n        grid-template-columns: 1fr\n    }\n\n    .variation-details {\n        grid-template-columns: repeat(2, 1fr)\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
